import { loadFonts } from './webfontloader'
loadFonts() // ต้องเรียกตรงนี้!